'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { useEffect, useRef } from 'react';

import { useCapiSubscribe } from '@/hooks/use-capi-subscribe';
import { createTrackingEventId } from '@/utils/capi-event';
import { setupMailerLiteSubscribeTracking } from '@/utils/mailerlite-subscribe-tracking';

/**
 * Sends a CAPI Subscribe event when a MailerLite embedded form is successfully submitted.
 */
const MailerLiteSubscribeTracker = () => {
  const { trackSubscribe } = useCapiSubscribe();
  const trackSubscribeRef = useRef(trackSubscribe);
  trackSubscribeRef.current = trackSubscribe;

  useEffect(
    () =>
      setupMailerLiteSubscribeTracking(data => {
        const eventId = createTrackingEventId();

        // Same event_id pairs the GTM/Pixel Subscribe with the CAPI event for dedup.
        sendGTMEvent({ event: 'ml_subscribe', event_id: eventId });

        trackSubscribeRef.current({
          ...data,
          id: eventId,
          sourceUrl: window.location.href,
        });
      }),
    [],
  );

  return null;
};

export default MailerLiteSubscribeTracker;
